import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';

const basePath = '/assetUploadLog';

export const processAssetUploadLog = <T>(sport: string, league: string, season: string, qualifiers: string[], firstUploadOnly: boolean): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/processLogs`, {
  sport,
  league,
  season,
  qualifiers,
  firstUploadOnly,
});
